import { NeuronProvider as Provider } from "@sphtech/neuron";
import { ReactElement, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function NeuronProvider({ children }: Props): ReactElement {
  return (
    <Provider
      config={{
        sessionApiUrl: import.meta.env.VITE_NEURON_API_URL,
        sessionApiToken: import.meta.env.VITE_NEURON_API_TOKEN,
      }}
    >
      {children}
    </Provider>
  );
}
